import { Grid, Table, TableCell, TableRow, TableHead, TableBody, TablePagination, TableFooter } from "@mui/material";
import { useContext, useEffect, useState } from "react"
import Moment from "react-moment";
import { ItemListRequest, ItemListResponse } from "helpers/intefaces";
import axios from 'axios';
import { ticketDetailsContext } from "../TicketDetailsContext";


export interface IActivities {
    message: string
    author: string
    date: string
}

interface ISearchActivities extends ItemListRequest {
    ticketId: string
}

let Activities = () => {
    
    let { ticket, ticketWatchers } = useContext(ticketDetailsContext)

    const [activities, setActivities] = useState<IActivities[]>([])
    const [search, setSearch] = useState<ISearchActivities>({
        pageNr: 0,
        pageSize: 10,
        ticketId: ticket.ticketId
    })

    useEffect(() => {
        getTicketActivities(search)
    }, [ticket, ticketWatchers])
    
    const [recordCount, setRecordCount] = useState(0);

    let getTicketActivities = async (searchRequest: ISearchActivities) => {
        try {
            setSearch(searchRequest);

            let response = await axios.get<ItemListResponse<IActivities>>('/api/TicketActivity/GetTicketActivities', {
                params: searchRequest
            });
            setActivities(response.data.items);
            setRecordCount(response.data.recordCount);

        } catch (error) { }
    }

    let changePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page,
            ticketId: ticket.ticketId,
            pageSize: 10
        } as ISearchActivities

        setSearch(request)
        getTicketActivities(request);

        window.scrollTo(0, 0);
    }


    return (
        <Grid container>
            <Grid item xs>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Descrizione</TableCell>
                            <TableCell>By</TableCell>
                            <TableCell>On</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {activities.map((activity, i) =>
                            <TableRow key={activity.date + activity.author + i}>
                                <TableCell>{activity.message}</TableCell>
                                <TableCell>{activity.author}</TableCell>
                                <TableCell>
                                    <Moment date={activity.date} format="L LT" />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {recordCount === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={3}><i>Nessuna attività trovata</i></TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
                <TablePagination
                    rowsPerPageOptions={[search.pageSize]}
                    component="div"
                    count={recordCount}
                    rowsPerPage={search.pageSize}
                    page={search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={(e, page) => changePage(page)}
                    labelDisplayedRows={({ page }) =>
                        <span>Trovate {recordCount} attività&nbsp;&middot;&nbsp;pagina {page + 1} di {Math.ceil(recordCount / search.pageSize)}</span>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default Activities